import selectEntityItem from "./entityItem"

export default function selectInvolved(state, model, id) {
  const entityItemState = selectEntityItem(state, model, id)
  return entityItemState ? entityItemState.involved : false
}
